import type { FC } from 'react'

import { useQuery } from '@tanstack/react-query'
import { Link } from 'react-router-dom'

import { useAppContext } from '@/app/index.context'
import { Translation } from '@/app/translations/Translation'
import SystemMessage from '@/components/SystemMessage'
import { commonQueries } from '@/resources/queries'
import { commonSystemMessagesResources } from '@/resources/system-messages'
import { APP_ROUTES } from '@/util/app-routes'

import './SystemMessageList.styles.scss'

const SystemMessageList: FC<{
  seenMessages?: number[]
  onSeenMessagesSet: (v: number[]) => void
  onBarClose: () => void
}> = ({ seenMessages, onSeenMessagesSet, onBarClose }) => {
  const { locale } = useAppContext()

  const { data } = useQuery(commonQueries.systemMessages(), commonSystemMessagesResources.getList)

  const messageList = data?.filter(message => message.locale === locale) || []

  if (!data || messageList.length === 0) return null

  const displayedMessage = messageList[0]

  return (
    <div className="system-messages">
      <h3 className="title">
        <Translation id="Notifications" />
      </h3>

      <div className="divider" />

      <div>
        <SystemMessage
          {...displayedMessage}
          seenMessages={seenMessages}
          onSeenMessagesSet={onSeenMessagesSet}
        />

        <div className="see-all-messages">
          <Link to={APP_ROUTES.SYSTEM_MESSAGES} onClick={onBarClose}>
            <Translation id="See all notifications" className="lower-case" />
          </Link>
        </div>

        <div className="divider" />
      </div>
    </div>
  )
}

export default SystemMessageList
